
import { Box } from '@mui/material';
import SignUpForm from '../../components/auth/signup/signup';

function SignUpPage() {

  return (
    <Box height={"100vh"}>
  <SignUpForm/> 
    </Box>
  );
}

export default SignUpPage;
